import * as actionTypes from '../actions/actionTypes'

const initialState = {
  token: null,
  user: null,
  permissions: null,
  error: null,
  loading: true,
  isAdmin: false
}

const signInStart = (state, action) => {
  return {
    ...state,
    loading: true,
    error: null
  }
}

const signInSuccess = (state, action) => {
  return {
    ...state,
    error: null,
    token: action.token,
    user: action.userInfo,
    permissions: action.userPermissions,
    loading: false,
    isAdmin: action.userInfo.roles.some(role => role.is_admin)
  }
}

const signInFailed = (state, action) => {
  return {
    ...state,
    error: action.errorMessage,
    token: null,
    user: null,
    permission: null,
    loading: false
  }
}

const signOutStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const signOutSuccess = (state, action) => {
  return {
    ...state,
    error: null,
    token: null,
    user: null,
    permission: null,
    loading: false
  }
}

const signOutFailed = (state, action) => {
  return {
    ...state,
    error: action.errorMessage,
    loading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SIGNIN_START:
      return signInStart(state, action)
    case actionTypes.SIGNIN_SUCCESS:
      return signInSuccess(state, action)
    case actionTypes.SIGNIN_FAILED:
      return signInFailed(state, action)
    case actionTypes.SIGNOUT_START:
      return signOutStart(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
      return signOutSuccess(state, action)
    case actionTypes.SIGNOUT_FAILED:
      return signOutFailed(state, action)
    default:
      return state
  }
}

export default reducer
